import { useState } from "react";
import { motion } from "framer-motion";
import { EXTRA_GROUPS, formatBRL, slug } from "../data/menu";
import { Chapter } from "./Chapter";

export const ExtrasSection = ({ onAdd }) => {
  const [selected, setSelected] = useState({});

  return (
    <div>
      <Chapter number="05" title="Sorvetes & Picolés" accent="#06B6D4">
        Além do açaí: potes de sorvete para levar para casa e picolés para se
        refrescar. Escolha o sabor e adicione direto ao pedido.
      </Chapter>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {EXTRA_GROUPS.map((g, gi) => {
          const flavor = selected[g.id];
          return (
            <motion.article
              key={g.id}
              data-testid={`extra-card-${g.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (gi % 3) * 0.1 }}
              className="flex flex-col overflow-hidden rounded-[1.75rem] border border-purple-500/25 bg-[#2D0B5A]/60 transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div className="relative">
                <img
                  src={g.image}
                  alt={g.title}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover"
                />
                <span
                  data-testid={`extra-price-${g.id}`}
                  className="absolute right-4 top-4 rounded-full bg-emerald-400 px-4 py-1.5 font-syne text-sm font-extrabold text-[#1E053B] shadow-lg"
                >
                  {formatBRL(g.price)}
                  {g.unit ? ` ${g.unit}` : ""}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-syne text-lg font-extrabold text-white">{g.title}</h3>
                <p className="mt-1 text-xs text-purple-300/60">
                  {g.flavors.length} sabores disponíveis
                </p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {g.flavors.map((f) => {
                    const active = flavor === f;
                    return (
                      <button
                        key={f}
                        type="button"
                        data-testid={`extra-flavor-${g.id}-${slug(f)}`}
                        onClick={() => setSelected((s) => ({ ...s, [g.id]: f }))}
                        className={`rounded-full border px-3.5 py-2 text-xs font-semibold transition-all duration-200 ${
                          active
                            ? "border-transparent font-bold text-[#1E053B]"
                            : "border-purple-500/25 bg-white/5 text-purple-100 hover:border-purple-300/50"
                        }`}
                        style={active ? { backgroundColor: g.color } : undefined}
                      >
                        {f}
                      </button>
                    );
                  })}
                </div>

                <button
                  type="button"
                  data-testid={`extra-add-${g.id}`}
                  disabled={!flavor}
                  onClick={() => {
                    onAdd({
                      title: `${g.title} · ${flavor}`,
                      details: [],
                      unitPrice: g.price,
                      qty: 1,
                    });
                    setSelected((s) => ({ ...s, [g.id]: undefined }));
                  }}
                  className="mt-6 w-full rounded-full bg-emerald-400 py-3.5 font-grotesk text-xs font-bold uppercase tracking-[0.15em] text-[#1E053B] transition-all duration-300 enabled:hover:scale-[1.03] enabled:active:scale-95 disabled:cursor-not-allowed disabled:opacity-40"
                >
                  {flavor ? `Adicionar ${flavor} · ${formatBRL(g.price)}` : "Escolha um sabor"}
                </button>
              </div>
            </motion.article>
          );
        })}
      </div>
    </div>
  );
};
